<template>
  <div class="container mt-1 pt-2">
    <div class="bg-light m-1 p-1 border-radius projects" v-for="(project, index) in projects" :key="index">
      <div class="d-flex">
        <div class="col-12">
          <h4 class="mt-1" @click="clickProject(project.info)">
            {{ project.products.length }} {{ $tc('project', project.products.length) }}
          </h4>
        </div>
      </div>
      <div v-for="(item, index) in project.products" :key="index" class="d-flex product" @click="clickProduct(item)">
        <div class="col-5 product-picture">
          <img :alt="item.title" :src="item.image" class="mw-100 border-radius">
        </div>
        <div class="col-7 d-flex flex-column justify-content-between product-info">
          <div>
            <div class="text-truncate" v-html="highlight(item.title)"></div>
            <div class="text-muted font-weight-light" v-html="$t('artnum') + ': ' + highlight(item.ordernumber)"></div>
          </div>
          <div class="mb-1 d-flex justify-content-end">
            <button :aria-label="$t('more_info')" :data-original-title="$t('more_info')" class="btn btn-primary btn-xs hasTooltip" data-container="body" data-placement="top" title="" type="submit">
              {{$t('more_info')}} <i class="fas fa-angle-right ml-1"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="flex showall text-right mb-1">
        <div class="col-12" @click="clickProject(project.info)">{{$t('link2projects')}}</div>
      </div>
    </div>

    <div class="bg-light m-1 p-1 border-radius products" v-if="products.length > 0">
      <div class="flex">
        <div class="col-12">
          <h4 class="mt-1">{{ $tc('products', products.length) }}</h4>
        </div>
      </div>
      <div v-for="(item, index) in products" :key="index" class="d-flex product" @click="clickProduct(item)">
        <div class="col-5 product-picture">
          <img class="mw-100 border-radius" :src="item.image" :alt="item.title">
        </div>
        <div class="col-7 d-flex flex-column justify-content-between product-info">
          <div>
            <div class="text-truncate" v-html="highlight(item.title)"></div>
            <div class="text-muted font-weight-light" v-html="$t('artnum') + ': ' + highlight(item.ordernumber)"></div>
          </div>
          <div class="mb-1 d-flex justify-content-end">
            <button :aria-label="$t('more_info')" :data-original-title="$t('more_info')" class="btn btn-primary btn-xs hasTooltip" data-container="body" data-placement="top" title="" type="submit">
              {{$t('more_info')}}<i class="fas fa-angle-right ml-1"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="flex showall text-right mb-1">
        <div class="col-12" @click="clickSubmitForm({query})">{{$t('findAll')}} <strong>{{ query }}</strong></div>
      </div>
    </div>

    <div v-if="categories.length > 0 || suggestions.length > 0" class="row">
      <div v-if="suggestions.length > 0" class="col-12 mt-2 suggestions">
        <h4 class="p-2">{{ $t('suggestion') }}</h4>
        <div v-for="(item, index) in suggestions" :key="index" class="p-2 suggestions-item" @click="clickSubmitForm({query: item})">
          <span v-html="highlight(item)"></span>
        </div>
      </div>

      <div v-if="categories.length > 0" class="col-12 mt-2 categories">
        <h4 class="p-2">{{ $t('category') }}</h4>
        <div v-for="(item, index) in categories" :key="index" class="p-2 suggestions-item" @click="clickCategory(item)">
          <span v-html="highlight(item.prefix)"></span>
          <span v-if="item.main" class="fas fa-angle-down ml-1"></span>
          <div v-html="highlight(item.main)"></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import searchResults from "./class/searchResults";

export default {
  name: "searchResultsMobile",
  mixins: [searchResults],
}
</script>

<style>
.suggestions-item {
  border-top: 1px solid #f0f0f0;
}

.mobile-result .product {
  margin: 15px 0;
}

.mobile-result .showall {
  color: #0061a1;
  text-decoration: underline;
}
</style>
